import {createAction} from "redux-act";
import {GameStatusEnum, PositionEnum} from "apps/BUDWEISERPOTM/modules/enums";

export const setActualRound = createAction<number>();
export const setActualCompetition = createAction<number>();
export const setActualMatchup = createAction<number>();

export interface IPredictorGame {
	roundId: number;
	roundName: string;
	id: number;
	homeSquadId: number;
	homeSquadFeedId: number;
	homeSquadName: string;
	homeSquadAbbreviation: string;
	homeScore: number;
	homeFlagUrl: string;
	awaySquadId: number;
	awaySquadFeedId: number;
	awaySquadName: string;
	awaySquadAbbreviation: string;
	awayScore: number;
	awayFlagUrl: string;
	venueId: number;
	venueName: string;
	stageName: string;
	status: GameStatusEnum;
	date: string;
	minute: number | null;
	winnerId: null | number;
	winnerName: null | string;
	qualifiedPlayers: IQualifiedPlayer[];
}

interface IQualifiedPlayer {
	id: number;
	minutes: number;
}

export const fetchGamesJSON = createAction();
export const fetchGamesJSONSuccess = createAction<IPredictorGame[]>();
export const fetchGamesJSONFailed = createAction<Error["message"]>();

export interface IPlayer {
	id: number;
	squadId: number;
	name: string;
	position: PositionEnum;
	squadAbbreviation: string;
	shortName?: string;
	feedId: number;
}

export interface IPlayerWithMinutes extends IPlayer {
	minutes?: number;
}

export const fetchPlayersJSON = createAction();
export const fetchPlayersJSONSuccess = createAction<IPlayer[]>();
export const fetchPlayersJSONFailed = createAction<Error["message"]>();
